import React from 'react';
import SelectForCountryCodes from './Selectors/SelectForCountryCodes';

export default class PhoneNumberInputField extends React.Component {
  static defaultProps = {
    className: 'form-control form-control-sm',
    fieldName: 'defaultFieldname',
    onChange: () => {},
    placeholder: '',
    value: '',
  };

  constructor(props) {
    super(props);
    let ccode = '+1';
    let num = '';
    ccode = this.getPart(props.value, 0, ccode);
    num = this.getPart(props.value, 1, num);
    this.state = {
      countryCode: ccode,
      phoneNumber: num,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      let ccode = this.state.countryCode;
      let num = this.state.phoneNumber;
      ccode = this.getPart(this.props.value, 0, ccode);
      num = this.getPart(this.props.value, 1, num);
      this.setState({
        countryCode: ccode,
        phoneNumber: num,
      });
    }
  }

  getPart(value, num, def) {
    if (!value) return '';
    if (value.split(')-').length !== 2) {
      return def;
    }
    let parts = value.split(')-');
    parts[0] += ')';
    return parts[num];
  }

  changeHandler(country, number) {
    this.props.onChange(`${country}-${number}`);
    //backtick character for template strings available with AltGr+7
  }

  render() {
    return (
      <div className={'d-flex ' + this.props.className.replaceAll('form-control', '').replaceAll('-sm', '')}>
        <SelectForCountryCodes
          value={this.state.countryCode}
          onChange={(e) => {
            this.setState({ countryCode: e.target.value });
            this.changeHandler(e.target.value, this.state.phoneNumber);
          }}
        />
        <input
          type='text'
          className={'form-control form-control-sm'}
          placeholder={this.props.placeholder}
          value={this.state.phoneNumber}
          onChange={(e) => {
            let numberstr = e.target.value;
            numberstr = numberstr.replaceAll(/[^0-9]/g, '');
            if (numberstr.substr(0, 1) === '0') {
              numberstr = numberstr.substring(1);
            }
            this.setState({
              phoneNumber: numberstr,
            });
            this.changeHandler(this.state.countryCode, numberstr);
          }}
          id={'htmlidfor' + this.props.fieldName}
          autoComplete='off'
        />
      </div>
    );
  }
}
